import { Combobox, PillsInput, useCombobox } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type InputFieldPropsType = {
  inputRef: React.RefObject<HTMLInputElement | null>;
  combobox: ReturnType<typeof useCombobox>;
  search: string;
  hasPills: boolean;
  onSearchChange: (search: string) => void;
  onRemoveLastPill: () => void;
  onEnterCommit: (highlightedIndex?: number) => void;
};

export const InputField: React.FC<InputFieldPropsType> = ({
  inputRef,
  combobox,
  search,
  hasPills,
  onSearchChange,
  onRemoveLastPill,
  onEnterCommit,
}) => {
  const { t } = useTranslation();

  return (
    <Combobox.EventsTarget>
      <PillsInput.Field
        ref={inputRef}
        onFocus={() => {
          combobox.openDropdown();
        }}
        onBlur={() => {
          combobox.closeDropdown();
        }}
        value={search}
        placeholder={hasPills ? '' : t('QUERY_BUILDER.PLACEHOLDER')}
        onChange={(event) => {
          combobox.updateSelectedOptionIndex();
          onSearchChange(event.currentTarget.value);
          combobox.openDropdown();
        }}
        onKeyDown={(event) => {
          if (event.key === 'Backspace' && search.length === 0 && hasPills) {
            event.preventDefault();
            onRemoveLastPill();
            return;
          }

          if (event.key !== 'Enter' && event.key !== 'Tab') return;

          event.preventDefault();

          const selectedOptionIndex = combobox.getSelectedOptionIndex();
          combobox.updateSelectedOptionIndex();

          onEnterCommit(selectedOptionIndex);
          combobox.closeDropdown();
        }}
      />
    </Combobox.EventsTarget>
  );
};
